import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { FieldConfig } from '../../../dynamic-form/models/field-config.interface';
import { DynamicFormComponent } from '../../../dynamic-form/dynamic-form.module';
import { environment } from '../../../../environments/environment';
import { ApiService, MetadataService } from '../../../ubi-core/ubi-core.module';

const API_URL = environment.apiUrl;

@Component({
  selector: 'ubi-dynamic-detail',
  templateUrl: './dynamic-detail.component.html',
  styleUrls: ['./dynamic-detail.component.scss']
})
export class DynamicDetailComponent implements OnInit, AfterViewInit {

  @ViewChild(DynamicFormComponent) form: DynamicFormComponent;

  @Input()
  entity: string;

  @Input()
  navigateUrl: string;

  item: any;
  error = '';

  config: FieldConfig[] = [
    {
      type: 'input',
      label: 'Id',
      name: 'Id',
      placeholder: 'Enter Id',
      disabled: true
    }
  ];

  options = {
    apiUrl: API_URL
  };

  status = {
    canDelete: false,
    canSave: false
  };

  constructor(protected baseservice: ApiService, protected metadataservice: MetadataService,
    protected router: Router, protected route: ActivatedRoute, protected location: Location,
    protected toastr: ToastrService) { }

  ngOnInit() {
    const id = +this.route.snapshot.params['id'];
    const entityFromRoute = this.route.snapshot.data['entity'];
    const navigateUrlFromRoute = this.route.snapshot.data['navigateUrl'];

    // caso existam os dois o @Input sobrepõe-se ao data do Router
    if (entityFromRoute !== null && entityFromRoute !== undefined
      && (this.entity === null || this.entity === undefined)) {
      this.entity = entityFromRoute;
    }

    // caso existam os dois o @Input sobrepõe-se ao data do Router
    if (navigateUrlFromRoute !== null && navigateUrlFromRoute !== undefined
      && (this.navigateUrl === null || this.navigateUrl === undefined)) {
      this.navigateUrl = navigateUrlFromRoute;
    }

    this.baseservice.setEntity(this.entity);

    this.metadataservice.getMetadataDetail()
      .subscribe(return_value => { this.config = return_value; },
      error => console.log('Error fetching Metadata: ' + error));

    if (!isNaN(id) && id !== null && id !== undefined) {
      this.baseservice.getById(id)
        .subscribe(return_value => {
          this.setValues(return_value);
        },
        error => console.log('Error fetching: ' + error));
    } else {
      this.item = {};
    }

  }

  protected setValues(values) {
    this.item = values;
    this.status.canDelete = true;
    this.form.setValues(this.item);
  }

  ngAfterViewInit() {
    let previousValid = this.form.valid;
    this.form.changes.subscribe(() => {
      if (this.form.valid !== previousValid) {
        previousValid = this.form.valid;
        this.status.canSave = previousValid;
      }
    });
    this.status.canSave = previousValid;
  }

  public save(event) {

    const formModel = this.form.value;
    this.item = Object.assign(this.item, formModel);

    this.baseservice.save(this.item)
      .subscribe(return_value => {
        if (return_value !== true) {
          this.item = return_value;
        }
        this.location.back();
      },
      error => {
        this.error = error;
        console.log('Error saving:' + error);
      });
  }

  public delete(event) {

    this.baseservice.delete(this.item)
      .subscribe(return_value => {
        this.location.back();
      },
      error => console.log('Error deleting:' + error));
  }

  public cancel(event) {
    this.location.back();
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/dynamic-entity/components/dynamic-detail/dynamic-detail.component.ts